import Chart from "react-apexcharts";

function BarChart({ title, data, suffix, metric }) {
  const yData = data.data;
  const categories = data.days;

  const options = {
    chart: {
      height: 350,
      type: "bar",
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val + suffix;
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (value) {
          const round2 = (num) => Math.round(num * 100) / 100;
          return `${round2(value)}${suffix}`;
        },
      },
    },

    xaxis: {
      categories: categories,
      position: "bottom",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return val + "%";
        },
      },
    },
    title: {
      text: title,
      align: "center",
    },
  };

  const series = [
    {
      name: metric,
      data: yData,
    },
  ];

  return <Chart options={options} series={series} type="bar" height={350} />;
}

export default BarChart;
